import { lazy } from 'react';

import { AnalyticsOutlined as IntelligenceIcon } from '@mui/icons-material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { EntitlementRouteWrapper } from '~/src/app/components/EntitlementRouteWrapper';
import { NavigationMenuCategory } from '~/src/app/components/Layout/components/NavigationMenu';
import { FeatureFlags } from '~/src/app/utils/featureflag/featureFlags';
import { useFeatureFlag } from '~/src/app/utils/featureflag/useFeatureFlag';
import { useDataEntitlements } from '~/src/hooks/useDataEntitlements';

const IntelligentBetaReport = lazy(() => import('./pages/IntelligentBeta'));
const IntelligenceAdmin = lazy(() => import('./pages/IntelligenceAdmin'));

export const IntelligenceRoutes = () => {
  const {
    dataEntitlements: { hasIntelligenceAccess },
    loading,
  } = useDataEntitlements();

  const intelligenceAdminFeatureFlag = useFeatureFlag(FeatureFlags.INTELLIGENCE_ADMIN);
  const showIntelligenceAdminNav = intelligenceAdminFeatureFlag?.enabled || false;

  return (
    <EntitlementRouteWrapper
      isAccessible={hasIntelligenceAccess}
      loading={loading || intelligenceAdminFeatureFlag === null}
    >
      <Routes>
        <Route key="labels" element={<IntelligentBetaReport />} path="labels" />
        <Route key="shipments" element={<IntelligentBetaReport />} path="shipments" />
        <Route key="spend" element={<IntelligentBetaReport />} path="spend" />
        {showIntelligenceAdminNav && (
          <Route key="admin" element={<IntelligenceAdmin />} path="admin" />
        )}
        <Route key="default" element={<Navigate to="labels" />} path="*" />
      </Routes>
    </EntitlementRouteWrapper>
  );
};

export const createIntelligenceNavigationCategory = (
  showIntelligenceAdminNav = false,
  intelligenceMlpEnabled = false,
): NavigationMenuCategory => ({
  beta: !intelligenceMlpEnabled,
  icon: <IntelligenceIcon color="secondary" />,
  items: [
    {
      name: 'intelligence.items.labels',
      route: '/intelligence/labels',
    },
    {
      name: 'intelligence.items.shipments',
      route: '/intelligence/shipments',
    },
    {
      name: 'intelligence.items.spend',
      route: '/intelligence/spend',
    },
    ...(showIntelligenceAdminNav
      ? [{ name: 'intelligence.items.admin', route: '/intelligence/admin' }]
      : []),
  ],
  name: 'intelligence.title',
});
